import { isGstExempt } from './validation';

export const getRequiredAttachments = ({ form, mode, isEdit, isNewBank = false, panRequired = true }) => {
  if (isEdit) {
    return isNewBank ? ['cancel_cheque_attachment'] : [];
  }

  const required = [];
  if (panRequired) {
    required.push('pan_attachment');
  }
  required.push('cancel_cheque_attachment');

  if (!isGstExempt(form.registration_type_of_gstin)) {
    required.push('gst_attachment');
  }
  if (String(form.msme_reg_no) === '1') {
    required.push('msme_attatchment');
  }
  if (String(form.msme_reg_no) === '0') {
    required.push('declaration_for_attatchment');
  }
  if (String(form.pf_reg_no) === '1') {
    required.push('pf_attatchement');
  }
  if (String(form.esic_reg_no) === '1') {
    required.push('esic_attatchemnt');
  }

  return required;
};

export const validateRequiredAttachments = ({
  form,
  files,
  mode,
  isEdit,
  isNewBank = false,
  panRequired = true,
}) => {
  const missing = getRequiredAttachments({ form, mode, isEdit, isNewBank, panRequired }).filter(
    (key) => !(files[key] instanceof File)
  );
  return missing;
};
